export const blogConstants = {
  GET_BLOG_ARTICLES:           'blog/GET_BLOG_ARTICLES',
}